// Do not add additional imports into this file (it is included in src/common/theme.js)

export const DOK_STANDARD_LABELS = {
  dok1: 'DOK 1',
  dok2: 'DOK 2',
  dok3: 'DOK 3',
  noDok: 'No DOK'
};

export const REVERSED_DOK_LABELS = {
  DOK1: 'dok1',
  DOK2: 'dok2',
  DOK3: 'dok3',
  NotApplicable: 'noDok',
  'Not Applicable': 'noDok'
};

export const getDOKThemeColors = palette => {
  const COLORS = [
    ...palette.volumetricColors[3],
    { main: '#ADB2B4', contrastText: '#FFF' }
  ];

  return 'dok3,dok2,dok1,noDok'
    .split(',')
    .reduce((themeObj, name, idx) => ({ ...themeObj, [name]: COLORS[idx] }), {});
};
